// Adres właściciela w recenzji ekstrakcji: jeden zbiorczy input ("Polna 3 83-140
// Gniew") z regexowym splitem jest wygodny, ale STRATNY dla adresów bez kodu /
// bez ulicy — te od razu pokazujemy jako 4 osobne pola strukturalne.

export interface OwnerAddress {
  street: string;
  building_no: string;
  postal_code: string;
  city: string;
}

// "Polna 3 83-140 Gniew" → street / building_no / postal_code / city.
export const ADDR_RE = /^(.*?)\s*(\S+)?\s*(\d{2}-\d{3})\s+(.+)$/;

export const joinAddress = (o: OwnerAddress): string =>
  [o.street, o.building_no, o.postal_code, o.city].filter(Boolean).join(" ");

export const splitAddress = (value: string): OwnerAddress => {
  const m = value.match(ADDR_RE);
  return m
    ? { street: m[1] ?? "", building_no: m[2] ?? "", postal_code: m[3] ?? "", city: m[4] ?? "" }
    : { street: value, building_no: "", postal_code: "", city: "" };
};

/** Czy zbiorczy input jest bezstratny dla tego adresu: join → split odtwarza
 *  dokładnie te same pola. Gdy nie (np. brak kodu pocztowego, sam numer bez
 *  ulicy) — modal od razu rozbija adres na pola strukturalne. */
export const addrRoundTrips = (o: OwnerAddress): boolean => {
  const joined = joinAddress(o);
  if (!joined) return true; // pusty adres — zwykły input wystarczy
  const back = splitAddress(joined);
  return (
    back.street === o.street &&
    back.building_no === o.building_no &&
    back.postal_code === o.postal_code &&
    back.city === o.city
  );
};
